export const viewerType: Readonly<any> = {
    Audit: 0,
    Script: 1
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/viewerType.ts